// extracted by mini-css-extract-plugin
module.exports = {"legend":"legend_legend__3QYdL","disabled":"legend_disabled__1ksLP","reducedMargin":"legend_reducedMargin__3msEj"};